import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgButterfly = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.75 7.62885V14.6288L9.36538 11.1288M14.75 7.62885L14.75 0.628845L9.36538 4.12885M14.75 7.62885L10.9808 7.62885M0.75 7.62885L0.75 14.6288L6.13462 11.1288M0.75 7.62885L0.75 0.628845L6.13462 4.12885M0.75 7.62885H4.51923M4.51923 7.62885L6.13462 4.12885M4.51923 7.62885L6.13462 11.1288M9.36538 4.12885L7.75 0.628846L6.13462 4.12885M9.36538 4.12885L10.9808 7.62885M10.9808 7.62885L9.36538 11.1288M6.13462 11.1288L7.75 14.6288L9.36538 11.1288",
		stroke: "black",
		strokeWidth: 1.5,
		strokeLinejoin: "bevel"
	})
});
export default SvgButterfly;
